import { createAction, props } from '@ngrx/store';

export const Subscribe = createAction('[Newsletter] Subscribe to newsletter', props<{ email: string }>());
export const SubscribeSuccess = createAction('[Newsletter] Subscribe to newsletter Success', props<{ result: any }>());
export const SubscribeFail = createAction('[Newsletter] Subscribe to newsletter Fail', props<{ error: any }>());

export const InitNewsletterPopup = createAction('[Newsletter] Initialize Newsletter dialog From Local Storage ');
export const InitNewsletterPopupSettingsFail = createAction(
  '[Newsletter] Initialize Newsletter Settings From Local Storage Fail',
  props<{ error: any }>()
);
export const ShowNewsletterPopup = createAction('[Newsletter] Show Newsletter Settings Dialog');
export const HideNewsletterPopup = createAction('[Newsletter] Hide Newsletter Settings Dialog');
export const clearNewsletterPopup = createAction('[Newsletter] Clear Newsletter Settings Dialog');
